import packageInfo from '../../package.json';

export const versionNumber = () => {
    const versionParts = packageInfo.version.split('.');

    const majorVersion = versionParts[0];
    const minorVersion = versionParts[1].length < 2 ? '0' + versionParts[1] : versionParts[1];
    const patchVersion = versionParts[2].length < 2 ? '0' + versionParts[2] : versionParts[2];

    return majorVersion + '.' + minorVersion + '.' + patchVersion;
};
